import React, { useRef, useEffect, useState} from "react";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Linkedin,
} from "lucide-react";
import Aos from "aos";
import "aos/dist/aos.css";




const ContactUs = () => {
  const form = useRef();
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const sendEmail = async (e) => {
  e.preventDefault();

  const formData = new FormData(form.current);
  const data = {
    name: formData.get("name"),
    company: formData.get("company"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    message: formData.get("message"),
  };

  // Show popup – sending
  setPopupMessage("Your enquiry is being sent...");
  setShowPopup(true);

  try {
    const res = await axios.post(
      "https://sairajinfo.com/backend/api/send-email",
      data
    );

    if (res.data.success) {
      setPopupMessage("Your enquiry has been sent successfully!");

      setTimeout(() => {
        setShowPopup(false);
        navigate("/");
      }, 2500);
    } else {
      setPopupMessage("Failed to send enquiry. Please try again.");

      setTimeout(() => {
        setShowPopup(false);
      }, 2500);
    }
  } catch (error) {
    setPopupMessage("Server error. Please try again later.");

    setTimeout(() => {
      setShowPopup(false);
    }, 2500);
  }
};


  useEffect(() => {
    Aos.init({ duration: 1200, once: false });
  }, []);

  return (
    <>
      <div
        className="min-h-screen bg-cover bg-center px-4 py-12 flex flex-col md:flex-row justify-between items-start gap-8"
        style={{ backgroundImage: `url('/Contact-bg.jpg')` }}
      >
        {/* Left Side: Form */}
        <div
          className="w-full md:w-1/2 max-w-xl bg-transparent backdrop-blur-lg shadow-2xl rounded-2xl p-8 md:p-12"
          data-aos="fade-right"
        >
          <div className="flex items-center gap-2 mb-2 text-white text-xl font-semibold">
            <Phone size={24} />
            <span>+91-9730657779</span>
          </div>
          <h2 className="text-3xl font-bold text-blue-950 mb-2">Let’s Talk</h2>
          <p className="text-white mb-6 text-2xl">
            Have a question or project in mind? Fill out the form and we’ll reach out to you shortly.
          </p>

          <form ref={form} onSubmit={sendEmail} className="space-y-5">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              className="w-full border border-white rounded-lg px-4 py-3 bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-950 transition"
            />
            <input
              type="text"
              name="company"
              placeholder="Company Name"
              required
              className="w-full border border-white rounded-lg px-4 py-3 bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-950 transition"
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              className="w-full border border-white rounded-lg px-4 py-3 bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-950 transition"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              className="w-full border border-white rounded-lg px-4 py-3 bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-950 transition"
            />
            <textarea
              name="message"
              placeholder="Enquiry Details"
              rows="4"
              required
              className="w-full border border-white rounded-lg px-4 py-3 bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-950 transition"
            ></textarea>
            <button
              type="submit"
              className="w-full bg-blue-950 text-white font-semibold py-3 rounded-lg hover:scale-95 transition"
            >
              Send Enquiry
            </button>
          </form>
        </div>

        {/* Right Side: Contact Info */}
        <div
          className="w-full md:w-1/2 max-w-md bg-transparent backdrop-blur-lg shadow-2xl rounded-2xl p-8 md:p-12"
          data-aos="fade-left"
        >
          <h2 className="text-3xl font-bold text-blue-950 mb-4">
            Contact Information
          </h2>
          <div className="space-y-4 text-white text-sm">
            <div className="flex items-center space-x-3 text-lg">
              <MapPin size={80} />
              <span>
                Office no 1, First Floor, Shree Dattatray Apartment, Pawan Nagar
                Lane No 2, Dapodi Road, Pimple Gurav, Pune 411061.
              </span>
            </div>
            <div className="flex items-center space-x-3 text-lg">
              <Phone size={30} />
              <span>+91-9730657779</span>
            </div>
            <div className="flex items-center space-x-3 text-lg">
              <Mail size={30} />
              <span>admin@sairajinfo.com</span>
            </div>
          </div>

          <h2 className="text-xl font-bold text-blue-950 mt-8 mb-3">
            Follow Us
          </h2>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/share/1AVEPGX19Y/"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook className="text-white hover:text-sky-400 scale-110 transition" size={24} />
            </a>
            <a
              href="https://www.linkedin.com/in/vishal-patil-03032932a/"
              target="_blank"
              rel="noreferrer"
            >
              <Linkedin className="text-white hover:text-sky-400 scale-110 transition" size={24} />
            </a>
          </div>
        </div>
      </div>

      {showPopup && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
       <div className="bg-white rounded-2xl shadow-2xl p-10 max-w-md w-full text-center animate-scale-in">
       <h2 className="text-2xl font-bold text-blue-950 mb-4">
        Please Wait
      </h2>
      <p className="text-lg text-gray-700">
        {popupMessage}
      </p>
    </div>
  </div>
)}

    </>
  );
};

export default ContactUs;
